import React from 'react';

// Minimal placeholder for the ACCESS_CHECK_FAILED screen wired up in Phase 4
// (docs/amends/user-access-restriction/tasks.md, P4-5). Distinct from
// SystemAccessDenied - this is a transient/infrastructure failure, not a
// confirmed policy denial, so it must not read like the user was rejected.
const AccessVerificationFailed = ({ reasonCode, correlationId, onRetry, onSignOut }) => {
    return (
        <div className="flex flex-col w-full items-center justify-center" style={{ padding: '3rem 1rem' }}>
            <h2>Unable to verify access</h2>
            <p>We couldn't confirm your access to this application right now. This is usually temporary.</p>
            {reasonCode && <p><small>Reference: {reasonCode}</small></p>}
            {correlationId && <p><small>Correlation ID: {correlationId}</small></p>}
            <p>
                <button onClick={onRetry}>Retry</button>
                {' '}
                <button onClick={onSignOut}>Sign out</button>
            </p>
        </div>
    );
};

export default AccessVerificationFailed;
